import { useEffect, useMemo, useState } from 'react';
import { fetchCurrentUser } from '../services/api/authService';

export default function useCurrentPermissions() {
  const [me, setMe] = useState(null);
  useEffect(() => { let active=true; fetchCurrentUser().then(v=>active&&setMe(v)).catch(()=>active&&setMe({permissions:[]})); return ()=>{active=false}; }, []);
  const permissions = useMemo(() => new Set(me?.permissions || []), [me]);
  return { me, can: (permission) => permissions.has(permission), loaded: me !== null };
}
